import { render, staticRenderFns } from "./receiving-address-sub.vue?vue&type=template&id=64c13568&scoped=true&"
import script from "./receiving-address-sub.vue?vue&type=script&lang=js&"
export * from "./receiving-address-sub.vue?vue&type=script&lang=js&"
import style0 from "./receiving-address-sub.vue?vue&type=style&index=0&id=64c13568&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c13568",
  null
  
)

export default component.exports